import React, { useEffect, useState } from 'react';
import { wtApiCall } from '../../helpers/commons/ApiWrapper';
import { lzNotifyErrorMessageFromResult } from '../../helpers/commons/notifications';
import { CButton, CCard, CCardBody, CCardHeader, CCardTitle } from '@coreui/react';
import DataTable from '../../widgets/DataTables/DataTable';
import RowCount from '../../widgets/DataTables/RowCount';
import getColumnSearchProps, { getDropdownSearchProps } from '../../widgets/Filters/ColumnSearch';
import './style.css';
import CIcon from '@coreui/icons-react';
import { cilFile } from '@coreui/icons';
import TenderTabs from '../../widgets/tabs/TenderTabs'
import SlidingTicker from '../SlidingTicker/SlidingTicker'
import {TenderModel, TYPE_NAMES,TYPE_DROPDOWN_OPTIONS, TENDER_STATUS_APPROVED, TENDER_CLOSED, TENDER_STATUS_HOD_APPROVED} from '../../models/tender.js'
import pdfIcon from "./pdf.png"

export default function CloseTenders() {
    const [isLoading, setIsLoading] = useState(true);
    const [data, setData] = useState([]);
    const [CloseTender, setCloseTender] = useState(0);
    const [filterTitle, setFilterTitle] = useState('');
    const [filterUploadDate, setfilterUploadDate] = useState('');
    const [filterOpenDate, setfilterOpenDate] = useState('');
    const [filterType, setFilterType] = useState('');
    const [filterTypeName, setFilterTypeName] = useState('');
    const [displayFromCount, setDisplayFromCount] = useState(0);
    const [displayToCount, setDisplayToCount] = useState(0);
    const [totalRecords, setTotalRecords] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);

    const changeValues = (key, val) => {
        if (key == 'type') {
          setFilterType(val.value)
          setFilterTypeName(val.label)
        }
    }

    const onTableChange = (pagination, filter, sorter) => {
        const current_page = pagination.current
        const Size = pagination.pageSize
        setPageSize(Size)
        setCurrentPage(current_page)
        getData(current_page, Size, sorter)
      }

    const getData = (page = '', size = '', sorter = {}) => {
        setIsLoading(true);
        wtApiCall(
            'tenders',
            {
                _page_index: page ? page : currentPage,
                _page_size: size ? size : pageSize,
                _sort_order: sorter ? sorter : [],
                tender_title: filterTitle,
                type: filterType,
                status: TENDER_CLOSED,
                open_date:filterOpenDate,
                upload_date:filterUploadDate,
                approval_status:TENDER_STATUS_HOD_APPROVED,

            },
            'get',
            (response) => {
                setData(response.data.data);
                setTotalRecords(response.data.total);
                setDisplayFromCount(response.data.from);
                setDisplayToCount(response.data.to);
                setIsLoading(false);
            },
            (error) => {
                lzNotifyErrorMessageFromResult(error);
            },
        );
    };
    const handleDownload = (media) => {
        const file = media;
        const fileUrl = file.file_preview_path; // or file.file_path if you need to construct the URL

        if (!fileUrl) {
            console.error("File URL is not defined");
            return;
        }

        const link = document.createElement('a');
        link.href = fileUrl;
        link.target = '_blank';

        // Extract file name from URL or use a default name
        const fileName = file.file_path.split('/').pop() || 'downloaded_file.pdf';
        link.download = fileName;

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const columns = [
        {
            key: 'tender_title',
            title: () => (
                <div>
                    Tender Title
                    {filterTitle && (
                        <>
                            <br />
                            <span style={{ color: 'blue' }}>
                                Filtering: <span style={{ color: 'green' }}>"{filterTitle}"</span>
                            </span>
                        </>
                    )}
                </div>
            ),
            // dataIndex: 'tender_title',
            width: 500, // Set your desired width here
            sorter: true,
            sortDirections: ['ascend', 'descend'],
            ...getColumnSearchProps('tender_title', filterTitle, setFilterTitle, getData),
            render: (record) => (
                <span>{record.tender_title} <br /> <span style={{color:'darkblue'}}>({record.tender_enquiry_no} Dated : {record.upload_date})</span></span>
            ),
        },
        {
            key: 'type',
            title: () => (
                <div>
                    Tender Type
                    {filterTypeName && (
                        <>
                            <br />
                            <span style={{ color: 'blue' }}>
                                Filtering: <span style={{ color: 'green' }}>"{filterTypeName}"</span>
                            </span>
                        </>
                    )}
                </div>
            ),
            dataIndex: 'type',
            render: (text, record) => (
                <span>
                    {TYPE_NAMES[text]}
                </span>
            ),
            width: 150, // Set your desired width here
            sorter: true,
            sortDirections: ['ascend', 'descend'],
            ...getDropdownSearchProps
            (
                'type', 
                TYPE_DROPDOWN_OPTIONS,
                changeValues,
                'Select tYPE',
                getData,     
            ),
        },
        {
            key: 'upload_date',
            title: () => (
                <div>
                    Upload Date
                    {filterUploadDate && (
                        <>
                            <br />
                            <span style={{ color: 'blue' }}>
                                Filtering: <span style={{ color: 'green' }}>"{filterUploadDate}"</span>
                            </span>
                        </>
                    )}
                </div>
            ),
            dataIndex: 'upload_date',
            sorter: true,
            width: 150, // Set your desired width here
            sortDirections: ['ascend', 'descend'],
            ...getColumnSearchProps('upload_date', filterUploadDate, setfilterUploadDate, getData),
        },
      
        {
            key: 'open_date',
            title: () => (
                <div>
                    Open Date
                    {filterOpenDate && (
                        <>
                            <br />
                            <span style={{ color: 'blue' }}>
                                Filtering: <span style={{ color: 'green' }}>"{filterOpenDate}"</span>
                            </span>
                        </>
                    )}
                </div>
            ),
            dataIndex: 'open_date',
            sorter: true,
            width: 150, // Set your desired width here
            sortDirections: ['ascend', 'descend'],
            ...getColumnSearchProps('open_date', filterOpenDate, setfilterOpenDate, getData),
        },
        {
            key: 'download',
            title: 'Download',
            dataIndex: 'media',
            width: 100, // Set your desired width here

            render: (text, record) => (

                record.media.map((item) => (
                    <a
                        color="info"
                        style={{ marginLeft: '10px' }}
                        onClick={() => handleDownload(item)}
                    >
                        <img src={pdfIcon} />
                    </a>
                ))
            ),
        },
    ];

    useEffect(() => {
        getData('', '', { order: 'ascend', columnKey: 'open_date' })

    }, []);

    return (
        <>
            {/* <SlidingTicker /> */}

            <TenderTabs tab_id={2} />

            <CCard className="card-dark container mt-1">
                <CCardHeader>
                    <CCardTitle className="text-black tenders-label">Tenders</CCardTitle>
                </CCardHeader>
                <CCardBody>
                    <DataTable
                        data={data}
                        columns={columns}
                        pageSize={pageSize}
                        totalRecords={totalRecords}
                        onTableChange={onTableChange}
                        isLoading={isLoading}
                        currentPage={currentPage}
                    />
                    <RowCount
                        displayFromCount={displayFromCount}
                        displayToCount={displayToCount}
                        totalRecords={totalRecords}
                    />
                </CCardBody>
            </CCard>
        </>
    );
}
